import Vue          from 'vue'
import Vuex         from 'vuex'
import approvalsApi from '@/api/v1/approvals'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

const state = () => ({
  approvalResponses: [],
  approvalRequests: [],
  requestTypes: [
    {name: 'General', type: 'general', routerLink: ''},
    {name: '---------------------', type: 'line', routerLink: ''},
    {name: '대체투자AI_리스크등급 보고서', type: 'report', routerLink: 'ReportsSignPage', title: '본 건 투자는 관계법령 및 회사의 자산운용기준에 따라 독립된 지위에서 공정하게 평가하였음을 확인합니다.'},
    {name: '투자심의위원회', type: 'report', routerLink: 'InvestmentReviewReport'},
    {name: '준법감시보고서', type: 'report', routerLink: 'ReportsSignPage', title: '본 건 투자는 관련 법규 및 신탁계약서에 위배되지 않음을 확인합니다.'},
    {name: '투자심의위원회 의사록', type: 'report', routerLink: 'InvestmentReportMinutes'},
    {name: '투자조건 체크리스트', type: 'report', routerLink: 'ReportsSignPage', title: '본건 계약은 상기와 같이 투자조건이 일치함을 확인합니다.'},
  ],
  statusTypes: [
    'request',
    'approved',
    'rejected',
  ]
})


const getters = {
  myApprovalResponsesCount: state => {
    return state.approvalResponses.length
  },
  myApprovalRequestsCount: state => {
    return state.approvalRequests.length
  },
  approvalResponsesByInvestment: state => investmentId => {
    return state.approvalResponses.filter(response => response.investment_id === investmentId)
  },
  approvalRequestsByInvestment: state => investmentId => {
    return state.approvalRequests.filter(request => request.investment_id === investmentId)
  },
  getField,
}


const actions = {
  getApprovalRequests ({ commit, dispatch }, filters={}) {
    return new Promise(resolve => {
      dispatch('activateLoading', null, { root : true })
      approvalsApi.getApprovalRequests(filters).then(resp => {
        commit('setApprovalRequests', resp)
        dispatch('deactiveLoading', null, { root : true })
        resolve()
      })
    })
  },  
  getNeedMyApprovalResponse ({ commit, dispatch }, filters={}) {
    return new Promise(resolve => {
      dispatch('activateLoading', null, { root : true })
      approvalsApi.getNeedMyApprovalResponse(filters).then(resp => {
        commit('setApprovalResponses', resp)
        dispatch('deactiveLoading', null, { root : true })
        resolve()
      })
    })
  },
  getNeedMyApprovalTotal ({ commit, dispatch }) {
    return new Promise(resolve => {
      dispatch('activateLoading', null, { root : true })
      approvalsApi.getNeedMyApprovalResponseForInvestment().then(resp => {
        commit('setApprovalResponses', resp)
        dispatch('deactiveLoading', null, { root : true })
        resolve()
      })
    })
  },
  updateApprovalStatus ({ commit, dispatch }, input) {
    dispatch('activateLoading', null, { root : true })
    input.approvalResponses.forEach(approvalResponse => {
      approvalsApi.updateApprovalResponse({id: approvalResponse.id, status: input.status.status, comment: input.status.comment }).then(resp => {
        commit('removeApprovalResponseFromList', resp.id)
      })
    })
    dispatch('deactiveLoading', null, { root : true })
  },
}


const mutations = {
  removeApprovalResponseFromList (state, approvalResponseId) {
    const index = state.approvalResponses.findIndex(approvalResponse => approvalResponse.id === approvalResponseId)
    if (index >= 0) {
      state.approvalResponses.splice(index, 1)
    }
  },
  setApprovalResponses (state, approvalResponses) {
    state.approvalResponses = approvalResponses
  },
  setApprovalRequests (state, approvalRequests) {
    state.approvalRequests = approvalRequests
  },
  updateField
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
